import { render, staticRenderFns } from "./SocketController.vue?vue&type=template&id=0d2a6b87&"
import script from "./SocketController.vue?vue&type=script&lang=js&"
export * from "./SocketController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports